import { TableDataBaseExpandable } from '../../../types';

export default function isTableDataBaseExpandable(candidate: any): candidate is TableDataBaseExpandable[] {
  if (Array.isArray(candidate) && (candidate.length === 0 || ('id' in candidate[0] && 'expand' in candidate[0]))) {
    return true;
  }

  return false;
}
